"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function get() {
    return _common.MARKING_TYPE;
  }
});
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _common = require("../../common");
require("./Label.scss");
var Label = function Label(_ref) {
  var children = _ref.children,
    className = _ref.className,
    htmlFor = _ref.htmlFor,
    onClick = _ref.onClick,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _common.MARKING_TYPE.none : _ref$markingType,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      required: '*',
      optional: '(optional)'
    } : _ref$text;
  var rootClassName = (0, _classnames["default"])('cds-Label', className);
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: rootClassName,
    htmlFor: htmlFor,
    onClick: onClick
  }, children, markingType === _common.MARKING_TYPE.required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-Label-Required"
  }, text.required), markingType === _common.MARKING_TYPE.optional && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-Label-Optional"
  }, text.optional));
};
exports.Label = Label;
Label.config = {
  markingType: _common.MARKING_TYPE
};